/**!*******************************************************************
 *
 * Copyright (c) Epic AI GmbH. All rights reserved.
 * Author:  Alexander Claas
 *
 ********************************************************************!*/

import MdCheckbox from "./MdCheckbox.vue";

export { MdCheckbox };
